<template>
  <div class="listen">
    <ComponentEmpty
      v-if="listenData.length == 0"
      title="暂无听课记录"
      tips=""
    />
    <ul v-else v-infinite-scroll="load">
      <li v-for="(item, index) in listenData" :key="index">
        <div class="listenDiv">
          <!--          时间-->
          <div class="listenTimesDiv">
            <div class="listenTimesText">
              <span>{{ item.watchTime | isDay }}</span>
              <p>{{ item.watchTime | isTimes }}</p>
            </div>
            <i></i>
          </div>
          <!--          内容-->
          <div class="listenData">
            <!-- <span class="stateSpan"></span> -->
            <div class="listenDataText">
              <div class="listenDataTextImg">
                <el-image class="imgSize" :src="item.thumb" v-if="item.thumb" />
                <el-image
                  class="imgSize"
                  :src="require('@/views/business/record/image/mycourse.jpg')"
                  v-else
                />
              </div>
              <div class="listenDataTextData">
                <p class="title">{{ item.title }}</p>
                <p class="lecturer">{{ item.watchTime }}</p>
                <div class="info-box">
                  <el-row>
                    <!--                    <el-col :span="5">-->
                    <!--                      <p><i></i>{{ item.watchTime }}</p>-->
                    <!--                    </el-col>-->
                    <el-col :span="4">
                      <p>
                        已学：<span>{{ item.sum_learn_rate }}</span>
                      </p>
                    </el-col>
                    <el-col :span="6">
                      <p>
                        用时：<span>{{ item.sum_watch_time }}</span>
                      </p>
                    </el-col>
                    <el-col :span="14">
                      <div class="el-con">
                        <div>学习至：</div>
                        <div class="name">
                          {{ item.section_title }}
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="buttonDiv">
                <el-button
                  @click="goLearning(item)"
                  class="opera-btn"
                  type="primary"
                  >继续学习</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { learnRecord } from "@/api/realTest";
import { mapState } from "vuex";
export default {
  name: "Listen",
  data() {
    return {
      listenData: [],
      fromData: {
        start: 1,
        perPage: 10,
      },
      totalNum: 0,
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState("common", {
      studentMajorUuid: (state) => state.studentMajorUuid,
    }),
  },
  filters: {
    isDay(val) {
      if (!val) return;
      const [time] = val.split(" ");
      const [, , day] = time.split("-");
      return day;
    },
    isTimes(val) {
      if (!val) return;
      const [time] = val.split(" ");
      return time;
    },
    isVal(val) {
      if (!val) return "0";
      return val + "%";
    },
    // 秒转分时秒
    timer: (value) => {
      let second;
      let minute;
      let hours;
      if (value >= 60) {
        //  获取分
        minute = value / 60;
        second = value % 60;
        if (minute > 60) {
          hours = minute / 60;
          minute = minute % 60;
        }
      } else if (value < 60) {
        // debugger
        return value + "秒";
      }
      if (hours) {
        return (
          parseInt(hours) +
          "小时" +
          parseInt(minute) +
          "分" +
          parseInt(second) +
          "秒"
        );
      } else if (minute) {
        return parseInt(minute) + "分" + parseInt(second) + "秒";
      }
    },
  },
  methods: {
    load() {
      if (this.totalNum > this.listenData.length) {
        this.fromData.start += 1;
        this.getData();
      }
    },
    goLearning(item) {
      this.$router.push({
        name: "subject",
        query: {
          id: item.course_id,
          type: item.course_type,
        },
      });
    },
    async getData() {
      const data = await learnRecord();
      if (data.code === 200) {
        this.listenData = data.result;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$contentHeight: calc(100vh - 350px);
.listen {
  width: 100%;
}
.listen ul {
  width: 100%;
  height: $contentHeight;
  @extend %overScroll;

  li:first-child {
    .listenTimesDiv::after {
      top: 50%;
    }
  }
}
.listenDiv {
  width: 100%;
  display: flex;
  align-items: stretch;
}
.listenDiv .listenTimesDiv {
  width: 150px;
  // height: 140px;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 2px;
    width: 5px;
    height: 100%;
    border-left: 1px solid #dedede;
  }
}
.listenTimesText {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 34px;
}
.listenTimesText span {
  font-size: 28px;
  color: #666;
}
.listenTimesText p {
  font-size: 18px;
  color: #666;
}
.listenTimesDiv i {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  @include bgColor("primary");
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
  position: absolute;
  z-index: 10;
  right: 0;
  top: 50%;
  margin-top: -7px;
}
.listenData {
  flex: 1 1 auto;
  display: flex;
  // justify-content: space-between;
  // align-items: flex-end;
}
// .listenData .stateSpan {
//   width: 1px;
//   height: 140px;
//   background-color: #dedede;
//   margin-left: -7.5px;
// }
// li:first-child .listenData:first-child .stateSpan {
//   width: 1px;
//   height: 100px;
//   background-color: #dedede;
//   margin-left: -7.5px;
// }
.listenDataText {
  // width: 1030px;
  flex: 1 1 auto;
  margin-left: 30px;
  height: 100%;
  border-bottom: 1px solid #d5d5d5;
  display: flex;
  align-items: center;
  padding: 20px 0;
}
.listenDataTextImg {
  width: 190px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.listenDataTextImg .imgSize {
  width: 113px;
  height: 70px;
}
.listenDataTextData {
  // width: 700px;
  flex: 1 1 auto;
  height: 100%;
  color: #666;
  font-size: 15px;
}
.el-con {
  display: flex;
  overflow: hidden;

  .name {
    flex: 1 1 auto;
    width: 0;
    @extend %ellipse;
    color: #f97a1f;
  }
}
.listenDataTextData .title {
  color: #343434;
  font-size: 16px;
  // margin-top: 20px;
}
.listenDataTextData .lecturer {
  margin-top: 5px;
}
.listenDataTextData .info-box {
  margin-top: 15px;
}
//.listenDataTextData div p{margin-right: 15px}
.listenDataTextData div p span {
  color: #f97a1f;
}
.buttonDiv {
  display: flex;
  align-items: center;
}
</style>
